// Responsive menu
const $navToggle    = $('.navigation__toggle'),
  $navBackdrop  = $('.navigation__backdrop'),
  $navMenu      = $('.navigation__menu');

const toggleMenu = () => {
  let backdropActive = !!$navBackdrop.hasClass('active');

  // Backdrop needs some timeouts and extra classes for transition to work
  if(backdropActive) {
    $navBackdrop.removeClass('active');

    setTimeout(function () {
      $navBackdrop.removeClass('visible');
    }, 500);
  } else {
    $navBackdrop.addClass('visible');

    setTimeout(function () {
      $navBackdrop.addClass('active');
    });
  }

  // Toggle menu
  $navMenu.toggleClass('active');

  // Toggle button icon
  $navToggle.children('.svg-inline--fa').toggleClass('fa-bars fa-times');
};

$navToggle.on('click', function () {
  toggleMenu();
});

$navBackdrop.on('click', function () {
  toggleMenu();
});
